module.exports = __webpack_public_path__ + "static/media/comprar-alugar-imovel-em-joinville.8a3e7477.webp";